export const tableStyles = {
    container: {
        maxWidth: 1500,
        width: "95%",
        margin: "40px auto",
        padding: "20px",
        background: "#fff",
        borderRadius: "8px",
        boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "24px",
        borderBottom: "1px solid #eaeaea",
        paddingBottom: "16px",
    },
    title: {
        fontSize: "26px",
        fontWeight: 600,
        color: "#0b5c4c",
        margin: 0,
    },
    searchBox: {
        position: "relative",
        width: "350px",
    },
    searchInput: {
        padding: "10px 16px 10px 40px",
        borderRadius: "6px",
        border: "1px solid #d0d0d0",
        fontSize: "0.95rem",
        width: "100%",
        transition: "all 0.2s ease",
    },
    searchIcon: {
        position: "absolute",
        left: "12px",
        top: "50%",
        transform: "translateY(-50%)",
        color: "#666",
    },
    table: {
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: "0",
        fontFamily: "inherit",
        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    },
    th: {
        background: "#0b756c",
        color: "#fff",
        fontWeight: 600,
        padding: "14px 20px",
        textAlign: "left",
        position: "sticky",
        top: 0,
        zIndex: 1,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    td: {
        padding: "16px 20px",
        borderBottom: "1px solid #eaeaea",
        fontSize: "0.95rem",
        lineHeight: "1.5",
        verticalAlign: "top",
    },
    trEven: {
        background: "#f8fcfa",
    },
    trOdd: {
        background: "#ffffff",
    },
    pagination: {
        marginTop: "24px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    paginationInfo: {
        fontSize: "0.9rem",
        color: "#666",
    }
};
